import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import Philosophy from './components/Philosophy';
import TechnicalArchitecture from './components/TechnicalArchitecture';
import AuditSample from './components/AuditSample';
import Mission from './components/Mission';
import FounderBeta from './components/FounderBeta';
import Navigation from './components/Navigation';
import SystemLogicPipeline from './components/SystemLogicPipeline';
import SecurityFAQ from './components/SecurityFAQ';
import FinalCTA from './components/FinalCTA';
import UserJourney from './components/UserJourney';
import ValueProposition from './components/ValueProposition';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const homeSchemas = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'TWINODE',
    url: SITE_URL,
    description:
      'TWINODE 合併東方算法基線參數（八字）與硅谷行為經濟學。我們生成超精確、具體的個人運作手冊，為科技專業人士、自由工作者和創始人。',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'TWINODE',
    url: SITE_URL,
    logo: `${SITE_URL}/favicon.png`,
    description:
      'TWINODE 是一個全自動行為分析引擎，專為科技專業人士打造。我們不預測命運。我們計算環境變量和行為概率。',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'privacy@twinode.com',
      contactType: 'customer support',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '我的個人數據是安全的嗎？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的。我們利用零信任架構。您的出生數據和行為參數在傳輸過程中加密，僅僅用於算法計算。我們不賣或分享第三方數據。',
        },
      },
      {
        '@type': 'Question',
        name: '報告交付需要多久？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '管道是全自動化的。一旦您的 Tally 表單提交並通過白名單驗證，異步引擎通常在 5 分鐘內將 Notion 地址發送到您的收件箱。',
        },
      },
      {
        '@type': 'Question',
        name: '我可以購買一次報告並運行多個報告嗎？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '不可以。為了維護系統完整性並防止資源濫用，每個授權電子郵件被鎖定到一個單一的 State Lock 後，交付。一次購買等於一個完整的 TWINODE Core Report。',
        },
      },
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: 'TWINODE Personal Operating Manual',
    description:
      '一個 1,500+ 字的深度整合分析，提供系統架構分析、情感-專業綜合、歷史循環證據和一年的戰術行動協議，為科技專業人士、自由工作者和創始人。',
    brand: {
      '@type': 'Brand',
      name: 'TWINODE',
    },
    offers: {
      '@type': 'Offer',
      price: '39',
      priceCurrency: 'USD',
      availability: 'https://schema.org/InStock',
      description: 'The TWINODE Core Report — One-time purchase, lifetime access.',
    },
  },
];

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const existingScripts = document.querySelectorAll('script[data-schema="home"]');
    existingScripts.forEach((s) => s.remove());

    homeSchemas.forEach((schema, i) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-schema', 'home');
      script.setAttribute('data-schema-index', String(i));
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });

    return () => {
      document.querySelectorAll('script[data-schema="home"]').forEach((s) => s.remove());
    };
  }, []);

  return (
    <div className="bg-[#050508] text-white font-sans scroll-smooth">
      <Navigation scrolled={scrolled} />
      <div className="pt-20">
        <Hero />
        <Philosophy />
        <TechnicalArchitecture />
        <AuditSample />
        <Mission />
        <SystemLogicPipeline />
        <ValueProposition />
        <UserJourney />
        <FounderBeta />
        <SecurityFAQ />
        <FinalCTA />
      </div>
    </div>
  );
}